import { elements } from '#components/generics/js/styles.js'
import {
  tapUp
} from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import { get } from '#utilities/js/ea/ajax.js'
import href from '#utilities/js/ea/href.js'
import * as utilities from '#utilities/js/styles.js'

const onTapUp = object(tapUp, {
  passive,
  task: async (
    cell
  ) => {
    const container = closest(`[data-show-xfiles='docs']`, cell)

    if (container) {
      const { ownerDocument } = container
      const { value: docsType } = one('[type="hidden"][name="docstype"]', ownerDocument)
      const url = href('docs/req_xfiles_getdocs', {
        docstype: docsType,
        favorites: 1,
      })
      let promise = get(url, { target: cell })
      const loader = one(`.${elements.loader}`, container)
      const tableList = one(`.${elements.table_full}`, container)

      queueMicrotask(async () => {
        await wait(1000)

        if (promise) {
          if (loader && tableList) {
            loader.classList.remove(utilities.modifiers.display.none)
            tableList.classList.add(utilities.modifiers.display.none)
          }
        }
      })

      await promise
      promise = null
      if (loader) {
        loader.classList.add(utilities.modifiers.display.none)
      }
    }
  }
})

export default cell => {
  onTapUp.listen(cell)
}
